var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.loadStatus !== 'fail')?_c('div',{ref:"lottie-anim-root",style:(`width: ${_vm.$px2rem(_vm.width)}; height: ${_vm.$px2rem(_vm.height)};`)}):_c('img',{style:(`width: ${_vm.$px2rem(_vm.width)}; height: ${_vm.$px2rem(_vm.height)};`),attrs:{"src":_vm.fallbackImage,"draggable":"false","alt":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }